import dayjs from 'dayjs'
import { useMemo, useState } from 'react'
import ReactDatePicker from 'react-datepicker'
import Select from 'react-select'
import Paginator from '../../../components/Paginator'
import SelectAutoCompleteFilter from '../../../components/SelectAutocompleteFilter'
import { API_URL, STATI_PROPOSTA } from '../../../constants'
import { useQsFilters } from '../../../hooks/filters'
import { useProposteListCliente } from '../../../hooks/proposte'
import { proposteInitFilters } from '../ProposteFilters'
import { ProposteTable } from '../ProposteTable'

export default function ProposteCliente() {
  const { filters, uiFilters, setFilters } = useQsFilters(proposteInitFilters)

  const apiFilters = useMemo(
    () => ({
      page: String(filters.page),
      search: filters.search,
      ordering: filters.ordering,
      data_creazione__lte: filters.data_creazione__lte,
      data_creazione__gte: filters.data_creazione__gte,
      cliente: filters.cliente,
      stato: filters.stato,
      stato__in: (filters.stato__in ?? []).join(','),
    }),
    [filters]
  )

  const proposte = useProposteListCliente(apiFilters)
  return (
    <div className="page">
      <div className="row mt-4">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <h1 className="title">Proposte</h1>
        </div>
        <div className="col-12">
          <div className="bg-white p-2 border-bottom d-flex justify-content-between align-items-center w-100 rounded">
            <div className="d-flex align-items-center w-100">
              <div className="d-flex align-items-center">
                <label className="label-m text-body-secondary me-2">Periodo</label>
                <ReactDatePicker
                  selectsRange={true}
                  isClearable
                  placeholderText="Seleziona periodo"
                  className="form-control me-2 text-secondary"
                  startDate={filters.data_creazione__gte !== '' ? dayjs(filters.data_creazione__gte).toDate() : null}
                  endDate={filters.data_creazione__lte !== '' ? dayjs(filters.data_creazione__lte).toDate() : null}
                  dateFormat={'dd/MM/yyyy'}
                  onChange={(date) => {
                    if (!date[0]) {
                      setFilters({
                        data_creazione__gte: '',
                        data_creazione__lte: '',
                        stato__touched: true,
                        page: 1,
                      })
                    } else {
                      if (date[0]) {
                        setFilters({
                          data_creazione__gte: date[0] ? dayjs(date[0]).format('YYYY-MM-DD') : '',
                          data_creazione__lte: date[1] ? dayjs(date[1]).format('YYYY-MM-DD') : '',
                          stato__touched: true,
                          page: 1,
                        })
                      }
                    }
                  }}
                />
              </div>
              <div className="d-flex align-items-center ms-3">
                <label className="label-m text-body-secondary me-2">Cliente</label>
                <div style={{ width: '230px' }}>
                  <SelectAutoCompleteFilter
                    className="interventi-cliente-filter"
                    value={uiFilters.cliente ?? ''}
                    placeholder="Cerca cliente"
                    onChange={(value: any) => {
                      if (!value) {
                        return setFilters({
                          cliente: '',
                          page: 1,
                          stato__touched: true,
                        })
                      } else {
                        setFilters({
                          cliente: value.value,
                          page: 1,
                          stato__touched: true,
                        })
                      }
                    }}
                    url={`${API_URL}/bilance/cliente/options`}
                    isMulti={false}
                  />
                </div>
              </div>

              <div className="d-flex align-items-center ms-3 me-3">
                <label className="label-m text-body-secondary me-2">Stato</label>
                <div style={{ width: '275px' }}>
                  <Select
                    isMulti
                    isSearchable
                    placeholder={'Tutti gli stati'}
                    options={STATI_PROPOSTA}
                    openMenuOnClick={true}
                    hideSelectedOptions={true}
                    onChange={(value) => {
                      setFilters({ stato__in: value.map((v) => v.value), page: 1, stato__touched: true })
                    }}
                    value={STATI_PROPOSTA.filter((s) => uiFilters.stato__in?.includes(s.value))}
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      valueContainer: (base) => ({
                        ...base,
                        maxWidth: '300px',
                        flexWrap: 'nowrap',
                        overflowX: 'auto',
                        scrollbarWidth: 'none',
                      }),
                      multiValue: (base) => ({
                        ...base,
                        minWidth: 'fit-content',
                      }),
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="me-2 text-nowrap">
              Stai visualizzando {proposte.data?.count ?? 0} di {proposte.data?.full_count ?? 0} proposte
            </div>
          </div>
          <ProposteTable proposte={proposte} />
          <Paginator
            count={proposte.data?.count ?? 0}
            currentPage={uiFilters.page}
            goToPage={(page) => setFilters({ page, stato__touched: true })}
          />
          <div className="position-relative">
            <div
              className="position-absolute d-flex align-items-center"
              style={{
                top: '50%',
                left: 20,
                transform: 'translateY(-50%)',
              }}
            ></div>
          </div>
        </div>
      </div>
    </div>
  )
}
